import { z } from "zod";
import { Id, IsoDate } from "./ids.js";

/** One line, like "Always reply in British English" or "Never send invoices on Fridays". */
export const STANDING_RULE_MAX_LENGTH = 200;
/** Per bot, and again for the Space-wide list. */
export const STANDING_RULES_MAX = 30;

export const StandingRuleTextSchema = z
  .string()
  .trim()
  .min(1)
  .max(STANDING_RULE_MAX_LENGTH)
  .refine((text) => !/[\r\n]/.test(text), { message: "A rule is one line." });

export const StandingRuleSchema = z.object({
  id: Id,
  /** Null for a Space-wide rule. */
  botId: Id.nullable(),
  text: z.string(),
  updatedAt: IsoDate,
});
export type StandingRule = z.infer<typeof StandingRuleSchema>;

/**
 * The rules one bot follows: the Space's, then its own. `canEdit` is whether the caller may
 * change the bot's rules (its owner or a Space admin); `canEditSpace` the Space's (admins).
 */
export const StandingRulesViewSchema = z.object({
  canEdit: z.boolean(),
  canEditSpace: z.boolean(),
  space: z.array(StandingRuleSchema),
  bot: z.array(StandingRuleSchema),
});
export type StandingRulesView = z.infer<typeof StandingRulesViewSchema>;
